import React, { useEffect, useState } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

import { MdKeyboardArrowDown } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';
import avatar from '../data/avatar.jpg';
import { Cart, Chat, Notification, UserProfile } from '.';
import { getaxiosRequestWithToken } from "../api/api";
import { showToast } from '../services/toastifyservices';
import CommonSpinner from '../services/commonSpinner'
import { handleSession } from '../api/apiSessionHandle'
import endpoints from '../api/EndPoints';
import { PiBellLight } from "react-icons/pi";
import { useSelector } from 'react-redux';
import Pusher from 'pusher-js';
import { PiCalendarCheck } from "react-icons/pi";


//const user = JSON.parse(localStorage?.getItem('user'));

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (

  <TooltipComponent content={title} position="BottomCenter" cssClass="my-tooltip">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color: 'black', marginLeft: '10px' }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      {dotColor && (
        <span
          style={{ background: dotColor }}
          className="absolute inline-flex rounded-full h-2 w-2 top-2 right-2"
        />
      )}
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const navigate = useNavigate();
  const role = useSelector((state) => state.auth.role);
  const { currentColor, activeMenu, setActiveMenu, handleClick, isClicked, setScreenSize, screenSize } = useStateContext();
  const [showLogout, setShowLogout] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const token = localStorage.getItem('token');
 useEffect(() => {
  const audio = new Audio('/notification.mp3');
    var pusher = new Pusher("f5d7f359a1682ae86bd6", {
      cluster: "mt1",
    });

    var channel = pusher.subscribe("patient-channel");
    channel.bind("patient-event", function (data) {
audio.currentTime = 0;
    audio.play().catch(() => {});     const notificationMessage = ` ${data?.patient_name } has created a new appointment.`;
      setNotifications((prevNotifications) => [...prevNotifications, notificationMessage]);});
    return () => {
      channel.unbind("patient-event");
      pusher.unsubscribe("patient-channel");
    };
  }, []);

  const handleArrowClick = () => {
    setShowLogout(prevShowLogout => !prevShowLogout);
  };

  const handleLogoutClick = async () => {
    setLoading(true);

    const Payload = {
      token: token,
    };


    try {
      const response = await getaxiosRequestWithToken(endpoints.Logout);
      
      if (response.success) {
        setLoading(false);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/");
      }

    } catch (error) {

      setLoading(false);
      console.error("Error:", error);
      handleSession(error.response?.data, navigate);

    }

    setShowLogout(false);
  };

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [setScreenSize]);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize, setActiveMenu]);

  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  return (
    <div className="flex justify-between p-2 md:mr-6 md:ml-6 relative">
      <NavButton customFunc={handleActiveMenu} title="Menu" icon={<AiOutlineMenu />} color={currentColor} />
 
      <div className="flex items-center ml-auto">
        {role === "CommAssistant" && (
          <div className="relative">
            <PiBellLight size={20} className="cursor-pointer" onClick={()=>setShowNotification(!showNotification)} />
            {
              notifications.length > 0 && (
                <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-red-500 animate-pulse" />
              )
            }
            {showNotification && (
  <div
    className="absolute right-0 mt-1 w-80 bg-white rounded-lg shadow-lg z-50 border"
  >
   
    <div className="p-3 border-b font-semibold text-gray-700 flex justify-between items-center">
        <span className='text-blue-700'>Notifications</span>
        {notifications.length > 0 &&
         <button className='text-sm font-regular  hover:bg-gray-200 rounded-md  p-1' onClick={()=>setNotifications([])}>Clear All</button>
        }
       
    </div>

    <div className="max-h-60 overflow-y-auto">
      {notifications.length === 0 ? (
        <p className="p-4 text-sm text-gray-500 text-center">
          No notifications
        </p>
      ) : (
        notifications.map((item, index) => (
          <div
            key={index}
            className="p-2 text-sm border-b hover:bg-gray-100 cursor-pointer flex items-center"
          >
             <PiCalendarCheck className="m-2 text-xl text-blue-500" />
            <span>{item}</span>
          </div>
        ))
      )}
    </div>
  </div>
)}

            
          </div>
        )}
        <div className="flex items-center ml-4 relative">
          <TooltipComponent position="BottomCenter">
            <div
              className="flex items-center gap-2 cursor-pointer px-2 py-1 hover:bg-light-gray rounded-lg"
              onClick={handleArrowClick}
            >
              <img className="rounded-full w-8 h-8" src={avatar} alt="user-profile" />
              <p className="text-gray-400 text-14">
                {/* Optional: Display username */}
                {/* <span>Hi,</span> <span className="ml-1 font-bold">{user?.name}</span> */}
              </p>
              <MdKeyboardArrowDown className="text-gray-400 text-14" />
            </div>
          </TooltipComponent>
          {showLogout && (
            <button
              onClick={handleLogoutClick}
              style={{
                position: 'absolute',
                top: '40px',  // Adjusted to place button below arrow
                left: '0',
                backgroundColor: 'rgb(20, 40, 120)',
                padding: '5px 10px',
                borderRadius: '5px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                border: 'none',
                cursor: 'pointer',
                color: 'white'
              }}
            >
              Logout
            </button>
          )}
        </div>

        {isClicked.notification && <Notification />}
        {isClicked.chat && <Chat />}
        {isClicked.cart && <Cart />}
        {isClicked.userProfile && <UserProfile />}
      </div>
      {loading && <CommonSpinner />}

    </div>
  );
};

export default Navbar;
